;(function configModalClass ($) {
  'use strict'

  var OVERLAY_CLASS = 'ent-modal-overlay'
  var MODAL_OPEN_CLASS = 'ent-modal--open'

  function EntModal (options) {
    if (!options || !options.selector) throw new Error('Option Selector is Required!')
    this._node = $(options.selector)
    this._overlay = $('<div>').addClass(OVERLAY_CLASS)
  }

  EntModal.prototype.open = function openModal () {
    $('body').append(this._overlay)
             .css('overflow', 'hidden')
             .css('position', 'fixed')
    this._node.addClass(MODAL_OPEN_CLASS)
  }

  EntModal.prototype.close = function closeModal () {
    this._overlay.remove()
    $('body').css('overflow', '')
             .css('position', '')
    this._node.removeClass(MODAL_OPEN_CLASS)
  }

  window.EntModal = EntModal
})(window.$)
